import React from 'react'
import './collab.css'

const Collab = () => {
  return (
    <div className="main_clb">
        <div className="sec_clb1">
            <div className="sec_sub1_clb"><span>Looking for collaboration?</span></div>
            <div className="sec_sub2_clb"><h6>CONTACT US</h6></div>
        </div>


        <div className="sec_clb2">
        <div className="divider_clb"></div>
        </div>


        <div className="sec_clb3">
        <div className="sec_sub1_clb3"><span>I’m interested in working together</span></div>
            <div className="sec_sub2_clb3"><span>+1 827 48 89</span></div>
        </div>


        <div className="sec_clb4">
        <div className="divider_clb"></div>
        </div>


        <div className="sec_clb5">
        <div className="sec_sub1_clb5"><span>Have a project in mind? Send a message.</span></div>
            <div className="sec_sub2_clb5"><span>info@hub.com</span></div>
        </div>
    </div>
  )
}

export default Collab